import { BaseApplication } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';
import { ResourceBatch } from 'ohzi-core';
import { ViewManager } from 'ohzi-core';

import InitialView from './views/InitialView';
import LoaderView from './views/LoaderView';

export default class Loader extends BaseApplication
{
  constructor(api)
  {
    super();
    this.loader_view = undefined;
    this.second_step = false;

    this.api = api;
  }

  load()
  {
    let batch = new ResourceBatch();

    batch.add_json('config', 'media/3d-map/data/config.json', 20000);


    batch.load(ResourceContainer);

    this.check_resource_loading(batch, this.on_loader_ready.bind(this), 10);
  }

  on_enter()
  {
    this.loader_view.start();
  }

  on_loader_ready()
  {
    this.second_step = true;

    // let config = ResourceContainer.get_resource('config');

    ViewManager.set_initial_state_data({});

    this.initial_view = new InitialView();
    this.loader_view = new LoaderView(this.api);

    ViewManager.set_view(this.initial_view.name);
    ViewManager.go_to_view(this.loader_view.name, false);

    // Start render loop
    this.api.start();

    let batch = new ResourceBatch();

    batch.add_json('camera_positions', 'media/3d-map/data/camera_positions.json', 20000);

    batch.add_texture('radio-wave', 'media/3d-map/textures/radio-wave.png', 50000);

    batch.add_texture('festival-marker', 'media/3d-map/icons/3d-badgefestivals.png', 5000);
    batch.add_texture('golf-marker', 'media/3d-map/icons/3d-badgegolf.png', 5000);
    batch.add_texture('industrial-marker', 'media/3d-map/icons/3d-badgeindustrial.png', 5000);
    batch.add_texture('special-marker', 'media/3d-map/icons/3d-badgespecial-event.png', 5000);
    batch.add_texture('sports-marker', 'media/3d-map/icons/3d-badgesports.png', 5000);


    batch.add_texture('solar-marker', 'media/3d-map/icons/solar-marker.png', 50000);
    batch.add_texture('radio-marker', 'media/3d-map/icons/radio-marker.png', 50000);
    batch.add_texture('lte-marker', 'media/3d-map/icons/lte-marker.png', 50000);
    batch.add_texture('fence-marker', 'media/3d-map/icons/fence-marker.png', 50000);
    batch.add_texture('cctv-marker', 'media/3d-map/icons/cctv-marker.png', 50000);

    batch.add_texture('solar-html-image', 'media/3d-map/html-images/solar-54.jpg', 50000);
    batch.add_texture('radio-html-image', 'media/3d-map/html-images/radio-54.jpg', 50000);
    batch.add_texture('lte-html-image', 'media/3d-map/html-images/lte-54.jpg', 50000);
    batch.add_texture('fence-html-image', 'media/3d-map/html-images/fence-54.jpg', 50000);
    batch.add_texture('cctv-html-image', 'media/3d-map/html-images/cctv-54.jpg', 50000);

    batch.add_texture('gradient', 'media/3d-map/textures/gradient.png', 500000);
    batch.add_texture('grid', 'media/3d-map/textures/grid.png', 500000);
    batch.add_texture('heightmap', 'media/3d-map/textures/heightmap.png', 500000);
    batch.add_texture('noise', 'media/3d-map/textures/noise.png', 500000);
    batch.add_texture('clouds', 'media/3d-map/textures/clouds.png', 500000);

    batch.add_gltf('city', 'media/3d-map/models/city/city_v28B.gltf', 10000);
    batch.add_gltf('crowd', 'media/3d-map/models/crowd.glb', 10000);
    batch.add_gltf('trees', 'media/3d-map/models/trees.glb', 10000);
    

    batch.load(ResourceContainer);

    this.check_resource_loading(batch, this.on_assets_ready.bind(this), 10);
  }

  on_assets_ready()
  {
    this.loader_view.on_assets_ready();
  }

  check_resource_loading(batch, on_resources_loaded, timeout)
  {
    // console.log(batch.get_progress(), batch.get_loaded_bytes(), batch.get_total_bytes());
    if (this.second_step)
    {
      this.loader_view.set_progress(batch.get_progress());
    }

    if (batch.loading_finished)
    {
      if (batch.has_errors)
      {
        batch.print_errors();
      }
      else
      {
        on_resources_loaded();
      }
    }
    else
    {
      setTimeout(function()
      {
        this.check_resource_loading(batch, on_resources_loaded);
      }.bind(this), timeout);
    }
  }

  update()
  {
    // SceneController.update();
  }
}
